'use strict'
import { Meta } from 'types/pagination';
import { Token } from 'types/tokens';
import { create } from 'zustand';

type TokensStore = {
	tokens: Token[]
	tokensMeta?: Meta,

	tokensPage: number,

	setTokens: (tokens: Token[]) => void,
	setTokensMeta: (meta: Meta) => void
}

const tokensStore = create<TokensStore>(set => ({
	tokens:[],
	tokensMeta: undefined,
	tokensPage: 1,

	setTokens: tokens => set({ tokens }),
	setTokensMeta: tokensMeta => set({ tokensMeta }),
}))

export const useTokensStore = tokensStore